
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kluby",
      function () {
        return require("private-next-pages/kluby/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kluby"])
      });
    }
  